// extracted by mini-css-extract-plugin
export default {"rating":"XP-z","numberOfStars":"YP-z","count":"ZP-z","barGraphSpacing":"_P-z","barGraph":"aQ-z"};